import * as React from "react";
import type { Table as TanStackTable } from "@tanstack/react-table";
import { cn } from "../../lib/utils";

interface LoadingStateProps {
  colSpan: number;
}

export function renderDefaultLoadingState({ colSpan }: LoadingStateProps) {
  return (
    <tr>
      <td
        colSpan={colSpan}
        className="text-center py-12 text-surface-ink-neutral-muted"
      >
        <div className="flex items-center justify-center gap-2">
          <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-action-fill-primary-default" />
          <span>Loading...</span>
        </div>
      </td>
    </tr>
  );
}

export function renderDefaultEmptyState({ colSpan }: LoadingStateProps) {
  return (
    <tr>
      <td
        colSpan={colSpan}
        className="text-center py-12 text-surface-ink-neutral-muted"
      >
        No data available
      </td>
    </tr>
  );
}
